import ComponentManifestBase from '../../../base/ComponentManifest.base';
import type {
  ISyncedResolverClass,
  SyncedFetchManifest
} from '../../componentManifestResolver.types';
import type { ComponentManifestSyncedResolverConstructor } from './types';
import type { WixComponentManifest } from '../../../schema';
import ComponentManifestMerger from './ComponentManifest.merger';

class ComponentManifestResolver
  extends ComponentManifestMerger
  implements ISyncedResolverClass<WixComponentManifest>
{
  private fetchManifest: SyncedFetchManifest;

  constructor({ fetchManifest, manifest }: ComponentManifestSyncedResolverConstructor) {
    super({ manifest });
    this.fetchManifest = fetchManifest;
  }

  public fetchFromReference(ref: string) {
    this.referredComponentManifest = new ComponentManifestBase(this.fetchManifest(ref));

    const fetchedManifestReferredType = this.referredComponentManifest.getReferredType();

    if (fetchedManifestReferredType) {
      // recursively resolve all referred manifests
      const resolvedFetchedManifest = new ComponentManifestResolver({
        fetchManifest: this.fetchManifest,
        manifest: this.referredComponentManifest.getManifest()
      }).resolve();

      this.referredComponentManifest.setManifest(resolvedFetchedManifest);
    }
  }

  public resolve() {
    const manifestReferredType = this.mainComponentManifest.getReferredType();
    if (manifestReferredType) {
      this.fetchFromReference(manifestReferredType);
      this.mainComponentManifest.setReferredType(undefined);
    }
    return super.merge();
  }
}

export default ComponentManifestResolver;
